import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';
import dateHoursFields from '../../../form/dateHoursFields';

const managementTaskForm: Form<Documentation> = {
  key: 'managementTask',
  title: 'Geschäftsführungstätigkeit',
  fields: [
    ...dateHoursFields,
    {
      key: 'topic',
      label: 'Thema',
      fieldTypes: 'text',
    },
  ],
};

export default managementTaskForm;
